const stickyTHeadStyle = {
    position: "sticky",
    top: 0,
    zIndex: 10,
}

export default stickyTHeadStyle;